import React from 'react';
import Styled from 'styled-components';
import * as color from '../colors';

const RegularButton = Styled.button`
    outline: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    padding: ${(props) => (props.rounded ? '1.3rem 3rem' : '1.3rem 1.35rem')};
    transition: .2s;
    border: ${(props) =>
      props.bordered ? `solid 1px ${props.color.primary}` : 'none'};
    border-radius: ${(props) => (props.rounded ? '100rem' : '.5rem')};
`;

const BtnIcon = Styled.span`
height: 1.5rem;
width: 1.5rem;
overflow: hidden;
img{width: 100%;height:100%;object-fit:cover};
margin-right: 1rem;
`;

const PrimaryButton = Styled(RegularButton)`
    background-color: ${(props) => props.color.primary};
    color: ${(props) => props.color.white};
    &:hover{
    background-color: ${(props) => props.color.light};
    color: ${(props) => props.color.primary};
    }
`;

const SecondaryButton = Styled(RegularButton)`
    background-color: ${(props) => props.color.secondaryAlt};
    color: ${(props) => props.color.primary};
    &:hover{
    background-color: ${(props) => props.color.light};
    color: ${(props) => props.color.primary};
    }
`;

const WhiteButton = Styled(RegularButton)`
    background-color: ${(props) => props.color.white};
    color: ${(props) => props.color.primary};
    &:hover{
    background-color: ${(props) => props.color.light};
    color: ${(props) => props.color.primary};
    }
`;
const LightButton = Styled(RegularButton)`
    background-color: ${(props) => props.color.light};
    color: ${(props) => props.color.primary};
    &:hover{
    background-color: ${(props) => props.color.lightAlt};
    color: ${(props) => props.color.primary};
    }
`;

const Button = ({ type, text, rounded, icon, bordered, link, onClick }) => {
  if (type === 'primary')
    return (
      <PrimaryButton
        as={link ? 'a' : ''}
        href={link ? link.path : null}
        color={color}
        rounded={rounded}
        onClick={onClick}
        bordered={bordered}>
        {icon && (
          <BtnIcon>
            <img src={icon} alt="" />
          </BtnIcon>
        )}
        {text}
      </PrimaryButton>
    );

  if (type === 'secondary')
    return (
      <SecondaryButton
        as={link ? 'a' : ''}
        href={link ? link.path : null}
        color={color}
        rounded={rounded}
        onClick={onClick}
        bordered={bordered}>
        {icon && (
          <BtnIcon>
            <img src={icon} alt="" />
          </BtnIcon>
        )}
        {text}
      </SecondaryButton>
    );

  if (type === 'white')
    return (
      <WhiteButton
        as={link ? 'a' : ''}
        href={link ? link.path : null}
        color={color}
        onClick={onClick}
        rounded={rounded}
        bordered={bordered}>
        {icon && (
          <BtnIcon>
            <img src={icon} alt="" />
          </BtnIcon>
        )}
        {text}
      </WhiteButton>
    );
  if (type === 'light')
    return (
      <LightButton
        as={link ? 'a' : ''}
        href={link ? link.path : null}
        color={color}
        onClick={onClick}
        rounded={rounded}
        bordered={bordered}>
        {icon && (
          <BtnIcon>
            <img src={icon} alt="" />
          </BtnIcon>
        )}
        {text}
      </LightButton>
    );

  return (
    <RegularButton
      as={link ? 'a' : ''}
      href={link ? link.path : null}
      onClick={onClick}
      rounded={rounded}
      bordered={bordered}>
      {icon && (
        <BtnIcon>
          <img src={icon} alt="" />
        </BtnIcon>
      )}
      {text}
    </RegularButton>
  );
};

export default Button;
